// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gpeS_UHkal9Ipid1Xgo0{position:relative;align-self:flex-end}.vvFA6Cr3lxAve0ANZ5Cv{top:0;transform:translate(0%, -100%);-webkit-transform:translate(0%, -100%)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipContainer": `gpeS_UHkal9Ipid1Xgo0`,
	"top": `vvFA6Cr3lxAve0ANZ5Cv`
};
export default ___CSS_LOADER_EXPORT___;
